import { render, staticRenderFns } from "./LotteryForm.vue?vue&type=template&id=6f1a4bae&scoped=true&name=lottery-catalog&"
import script from "./LotteryForm.vue?vue&type=script&lang=js&"
export * from "./LotteryForm.vue?vue&type=script&lang=js&"
import style0 from "./LotteryForm.vue?vue&type=style&index=0&id=6f1a4bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a4bae",
  null
  
)

/* custom blocks */
import block0 from "./LotteryForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports